import loginedApi from "../apis/index";
import { DOCTOR_LISTING } from "./type";
import CryptoJS from "crypto-js";
var hashcode = CryptoJS.SHA256(
  process.env.REACT_APP_PREFIX +
    process.env.REACT_APP_TOKEN +
    process.env.REACT_APP_SECRETKEY
);

const { detect } = require("detect-browser");
const browser = detect();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B");
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D");
} //replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

export const fetch_doctors_v2 = async (speciality, clinicId, pagination) => {
  console.log(
    "Calling fetch doctors v2............................... ",
    clinicId,
    speciality,pagination
  );
  let resp = await loginedApi.post("getcountrycode", {
    token: hashcode.toString(),
    version: "2.0",
    data: { browserTimeZone: `GMT${formatTime}` },
    requestType: 1058,
  });
  const doctorscountrycode = resp.data.data;
  console.log("connection herrrrrrrrrrrrrrrrrrrrrrrr",clinicId)
  let params = {
    data: {
      clinicId: clinicId,
      todayRate: "74.27006",
      searchName: "",
      City: "",
      speciality: speciality,
      browserTimeZone: `GMT${formatTime}`,
      Ipaddress: doctorscountrycode.Ipaddress,
      useragent: userAgent,
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      Os: platform,
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,
    },
    requestType: "604",
    token: hashcode.toString(),
  };

  let getalldoctors = {
    requestType: "259",
    token: hashcode.toString(),
    data: {
      browserTimeZone: `GMT${formatTime}`,
      Ipaddress: doctorscountrycode.Ipaddress,
      useragent: userAgent,
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      Os: platform,
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,
      todayRate: "",
      clinicId: clinicId,
      searchName: "",
      City: "",
      offset: pagination,
    },
  };

  if (clinicId != "") {
    params.data.clinicId = clinicId;
  }

  let res = null;

  //Only if there is clinic id.................................
  console.log("Searching doctors......***.....................", clinicId);

  if (clinicId!=undefined && clinicId!=null && clinicId != "" ) {
    if (speciality && speciality != "ALL") {
      res = await loginedApi.post("searchDoctor", params);
    
    } else {
      res = await loginedApi.post("getdoctors", getalldoctors);
      
    }

    console.log(
      "Getting doctors...........................................................>",
      res
    );
    if (res.status === 200 && res?.data?.data?.info!="Sucess") {
      const doctors = res.data.data;
      console.log(
        "Getting doctors...........................................................>",
        doctors
      );

      let location = [];
      let hospitals = [];
      let languagesSet = [];

      doctors?.Hospitals.map((item) => {
        item && hospitals.push({ value: item, checked: false });
      });
      doctors?.citiesSet?.map((item) => {
        item && location.push({ value: item, checked: false });
      });
      doctors?.languagesSet.map((item) => {
        item && languagesSet.push({ value: item, checked: false });
      });

      
      return doctors;
    }
  } else {
    console.log(
      "No clinic id found to call doctors list..........................................................."
    );
  }
};

export const fetch_doctors =
  (speciality, clinicId, pagination) => async (dispatch) => {

    console.log("inside fetch_doctors");
    console.log("******************************",speciality, clinicId, pagination);

    let resp = await loginedApi.post("getcountrycode", {
      token: hashcode.toString(),
      version: "2.0",
      data: { browserTimeZone: `GMT${formatTime}` },
      requestType: 1058,
    });
    const doctorscountrycode = resp.data.data;

    let params = {
      data: {
        clinicId: clinicId,
        todayRate: "74.27006",
        searchName: "",
        City: "",
        speciality: speciality,
        browserTimeZone: `GMT${formatTime}`,
        Ipaddress: doctorscountrycode.Ipaddress,
        useragent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform,
        currency: doctorscountrycode.currency,
        accessCountry: doctorscountrycode.Country,
      },
      requestType: "604",
      token: hashcode.toString(),
    };

    let getalldoctors = {
      requestType: "259",
      token: hashcode.toString(),
      data: {
        browserTimeZone: `GMT${formatTime}`,
        Ipaddress: doctorscountrycode.Ipaddress,
        useragent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform,
        clinicId:"1000",
        currency: doctorscountrycode.currency,
        accessCountry: doctorscountrycode.Country,
        todayRate: "",
        searchName: "",
        City: "",
        count: pagination,
      },
    };

    if (clinicId != "") {
      params.data.clinicId = clinicId;
    }

    let res = null;

    //Only if there is clinic id.................................
    console.log("Searching searchDoctor......***.....................", clinicId);

    if (clinicId!=undefined && clinicId!=null && clinicId != "" ) {
      if (speciality && speciality != "ALL") {
        res = await loginedApi.post("searchDoctor", params);
        
      } else {
        res = await loginedApi.post("getdoctors", getalldoctors);
        
      }

     
      if (res.status === 200 && res?.data?.data?.info!="Sucess") {
        const doctors = res.data.data;
        console.log("Sres........", doctors);
        let location = [];
        let hospitals = [];
        let languagesSet = [];

        doctors?.Hospitals.map((item) => {
          item && hospitals.push({ value: item, checked: false });
        });
        doctors?.citiesSet?.map((item) => {
          item && location.push({ value: item, checked: false });
        });
        doctors?.languagesSet.map((item) => {
          item && languagesSet.push({ value: item, checked: false });
        });



        dispatch({
          type: DOCTOR_LISTING,
          payload: {
            speciality,
            doctors: doctors,
            location: location,
            hospitals: hospitals,
            languagesSet: languagesSet,
            indexCharacters: doctors?.indexCharacters,
          },
        });

        return doctors;
      }
    }
    console.log("******************************");
    console.log("**************end fetch_doctor****************");
  };

export const fetch_alldoctors = (count, clinicId) => async (dispatch) => {
  // let reduxData = useSelector(state => state)
  // console.log("88888888888",reduxData)
  console.info("clinicId************",clinicId)
  const countrycoderes = await loginedApi.post("getcountrycode", {
    token: "token",
    version: "2.0",
    data: { browserTimeZone: `GMT${formatTime}` },
    requestType: 1058,
  });

  const doctorscountrycode = countrycoderes.data.data;

  let params = {
    data: {
      clinicId: "",
      Ipaddress: doctorscountrycode.Ipaddress,
      useragent: userAgent,
      todayRate: "74.27006",
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,
      searchName: "",
      browserTimeZone: `GMT${formatTime}`,
      Os: platform,
      City: "",

      count: count,
    },
    requestType: "259",
    token: hashcode.toString(),
  };

  if (clinicId != "") {
    params.data.clinicId = clinicId;
  }

  let res;
  if (clinicId!=undefined && clinicId!=null && clinicId != "" ) {
    res = await loginedApi.post("getdoctors", params);
  }
  console.log("res-->", res);

  if (res?.status === 200) {
    const doctors = res.data.data;

    // let location = [{ value: "All", checked: false }];
    // let hospitals = [{ value: "All", checked: false }];
    // let languagesSet = [
    //   // { value: "All", checked: false },
    //   { value: "English", checked: false },
    //   { value: "Hindi", checked: false },
    //   { value: "Tamil", checked: false },
    //   { value: "Malayalam", checked: false },
    // ];

    let location = [];
    let hospitals = [];
    let languagesSet = [];

    doctors?.Hospitals.map((item) => {
      item && hospitals.push({ value: item, checked: false });
    });
    doctors?.citiesSet.map((item) => {
      item && location.push({ value: item, checked: false });
    });
    doctors?.languagesSet.map((item) => {
      item && location.push({ value: item, checked: false });
    });

    console.log(
      "Getting hospitals...........................................................>",
      doctors
    );

    dispatch({
      type: DOCTOR_LISTING,
      payload: {
        doctors: doctors,
        location: location,
        hospitals: hospitals,
        languagesSet: languagesSet,
        indexCharacters: doctors?.indexCharacters,
      },
    });
  }
};
